import {salesTermsRsTransformer} from '@/utils/api-helpers'

const incrementAmount = (total, price, exchangeRates) => {
    const currency = price.originalCurrency || price.currency,
        amount = price.originalAmount || price.amount
    total.amount +=
        currency === total.currency
            ? amount
            : Math.round(((amount * exchangeRates[currency]) / exchangeRates[total.currency]) * 100) / 100
}
export const initialZeroPrice = ({originalCurrency, currency}) => ({
    currency: originalCurrency || currency,
    amount: 0,
    loyaltyAmount: 0,
})

/**
 * For work with GPFE data price model - when currency same with originalCurrency - shown only currency and amount props
 * @param prices
 * @param exchangeRates
 * @returns {*}
 */
export const totalPrice = (prices, exchangeRates) => {
    if (!prices?.length) return undefined
    return prices.reduce((total, price) => {
        incrementAmount(total, price, exchangeRates)
        if (price.commission?.amount) {
            if (!total.commission) {
                total.commission = initialZeroPrice(prices[0])
            }
            incrementAmount(total.commission, price.commission, exchangeRates)
        }
        if (price.loyaltyAmount) {
            total.loyaltyAmount += price.loyaltyAmount
        }
        return total
    }, initialZeroPrice(prices[0]))
}

/**
 * @param additionalOptions
 * @param extraServices
 * @returns {{price: *, supplierPrice: *}}
 */
export const extraServicesTotalPrice = (additionalOptions, extraServices, exchangeRates) => {
    const prices = [],
        supplierPrices = []
    additionalOptions?.extraServices?.forEach(({salesTerms, serviceRPH}) => {
        const quantity = extraServices.find(extraService => extraService.serviceRPH === serviceRPH)?.quantity
        if (quantity) {
            // @ts-ignore
            const {price, supplierPrice} = salesTermsRsTransformer(salesTerms)
            prices.push({
                // @ts-ignore
                amount: (price.originalAmount || price.amount) * quantity,
                // @ts-ignore
                currency: price.originalCurrency || price.currency,
            })
            if (supplierPrice) {
                supplierPrices.push({
                    amount: (supplierPrice.originalAmount || supplierPrice.amount) * quantity,
                    currency: supplierPrice.originalCurrency || supplierPrice.currency,
                })
            }
        }
    })
    return {
        price: totalPrice(prices, exchangeRates),
        supplierPrice: totalPrice(supplierPrices, exchangeRates),
    }
}
